export enum WebToRNAction {
    OPEN_EFAKTURA = 'OPEN_EFAKTURA',
    OPEN_PDF = 'OPEN_PDF',
    OPEN_SETTINGS = 'OPEN_SETTINGS',
    LOGOUT = 'LOGOUT',
    OPEN_BROWSER = 'OPEN_BROWSER',
    OPEN_BROWSER_CALLBACK = 'OPEN_BROWSER_CALLBACK',
    COPY_TEXT = 'COPY_TEXT',
    SIGN = 'SIGN',
    OPEN_CHANGE_BANK = 'OPEN_CHANGE_BANK',
    TURN_ON_BIOMETRIC = 'TURN_ON_BIOMETRICS',
    TURN_OFF_BIOMETRIC = 'TURN_OFF_BIOMETRICS',
    ENABLE_PULL_TO_REFRESH = 'ENABLE_PULL_TO_REFRESH',
    SWITCH_BANK = 'SWITCH_BANK',
    GTP_REFRESH = 'GTP_REFRESH',
    GTP_PUSH_PROVISION = 'GTP_PUSH_PROVISION',
    UPDATE_ENABLE_PUSH_NOTIFICATIONS = 'UPDATE_ENABLE_PUSH_NOTIFICATIONS',
    SHOW_FEEDBACK_MODAL = 'SHOW_FEEDBACK_MODAL',
    SET_SIGNING_METHOD = 'SET_SIGNING_METHOD',
    SET_LOGIN_METHOD = 'SET_LOGIN_METHOD',
    STEP_UP_SECURITY = 'STEP_UP_SECURITY',
}

export interface SignEvent {
    bankIdUri?: string;
    dynamicLinkId: string;
}

export interface OpenBrowserCallbackEvent {
    uri: string;

    /**
     * in `some.scheme://myresult/ok`, `myresult/` is the callbackResultPrefix and `ok` is the result
     */
    callbackResultPrefix?: string;
}

export interface PdfEvent {
    url: string;
    title?: string;
}

export interface LogoutEvent {
    automaticLogout: boolean;
}

export interface UpdateEnablePushNotificationsEvent {
    enabled: boolean;
}

export interface GoogleWalletProvisionEvent {
    administrativeArea?: string;
    cardDisplayName: string;
    cardLastDigits: string;
    city?: string;
    countryCode?: string;
    networkCode: number;
    opc: string;
    phoneNumber?: string;
    postalCode?: string;
    tokenServiceProviderCode: number;
    userAddress1?: string;
    userAddress2?: string;
    userName?: string;
}

export interface WebToRNMessage {
    action: WebToRNAction;
    payload?:
        | string
        | number
        | SignEvent
        | OpenBrowserCallbackEvent
        | PdfEvent
        | LogoutEvent
        | GoogleWalletProvisionEvent
        | UpdateEnablePushNotificationsEvent;
}
